var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L1.53125 8.18182L1.53362 8.184C0.573957 9.42876 0 11.0084 0 12.7273C0 16.7439 3.13401 20 7 20C10.866 20 14 16.7439 14 12.7273C14 12.1901 13.9439 11.6665 13.8376 11.1624L7.5 17.5L1.66667 11.6667L4.16667 9.16667L7.5 12.5L12.2081 7.79188L7 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10L2.5 11.6667L4.83245 13.9985L4.86068 14.0332L7.5 16.6667L16.6667 7.5L15 5.83333L7.5 13.3333L4.16667 10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispensed);
export default __webpack_public_path__ + "static/media/Dispensed.32f24cd85d67aa176732d021e66d0f43.svg";
export { ForwardRef as ReactComponent };